import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { AlertTriangle, TrendingUp, Sparkles, Bell, Info as InfoIcon } from "lucide-react";

const LEVEL = {
    critical: { icon: AlertTriangle, cls: "bg-critical/10 text-critical border-critical/20", label: "Critico" },
    high: { icon: AlertTriangle, cls: "bg-warning/10 text-warning border-warning/20", label: "Alta priorità" },
    opportunity: { icon: Sparkles, cls: "bg-primary/[0.08] text-primary border-primary/20", label: "Opportunità" },
    monitor: { icon: TrendingUp, cls: "bg-azure/10 text-azure border-azure/20", label: "Da monitorare" },
    info: { icon: InfoIcon, cls: "bg-textsubtle/10 text-textmuted border-border", label: "Informativo" },
};

export default function AlertsPage() {
    const q = useQuery({ queryKey: ["alerts"], queryFn: () => api.get("/alerts").then((r) => r.data) });
    const items = q.data || [];
    return (
        <div className="space-y-6 pv-enter">
            <div>
                <div className="pv-eyebrow mb-2 flex items-center gap-1.5"><Bell size={11} strokeWidth={1.5} />Alert intelligenti</div>
                <h1 className="pv-serif text-4xl tracking-tight">Cosa richiede la tua attenzione</h1>
                <p className="text-[13.5px] text-textmuted mt-2 max-w-2xl">
                    Prime Vision AI monitora continuamente 40+ metriche e segnala anomalie prima che diventino problemi.
                </p>
            </div>

            <div className="space-y-3">
                {items.map((a) => {
                    const L = LEVEL[a.level] || LEVEL.info;
                    const Icon = L.icon;
                    return (
                        <div key={a.id} className="pv-card pv-hover p-5">
                            <div className="flex items-start gap-4">
                                <div className={`h-10 w-10 rounded-xl flex items-center justify-center border ${L.cls}`}>
                                    <Icon size={15} strokeWidth={1.5} />
                                </div>
                                <div className="flex-1 min-w-0">
                                    <div className="flex items-center gap-2 flex-wrap mb-1">
                                        <span className={`text-[10.5px] px-2 py-0.5 rounded-md uppercase tracking-wider font-medium ${L.cls} border`}>{L.label}</span>
                                        <span className="text-[10.5px] text-textsubtle">Scadenza {a.due}</span>
                                    </div>
                                    <div className="text-[15px] font-medium leading-snug">{a.title}</div>
                                    <div className="text-[12.5px] text-textmuted mt-1.5">{a.description}</div>
                                    <div className="mt-3 grid md:grid-cols-2 gap-3 text-[12px]">
                                        <div>
                                            <div className="pv-eyebrow mb-1">Possibile causa</div>
                                            <div className="text-textmain leading-snug">{a.cause}</div>
                                        </div>
                                        <div>
                                            <div className="pv-eyebrow mb-1">Azione suggerita</div>
                                            <div className="text-textmain leading-snug">{a.suggested_action}</div>
                                        </div>
                                    </div>
                                    <div className="mt-3 pt-2 border-t border-border/[var(--border-opacity)] flex items-center justify-between text-[11px] text-textsubtle">
                                        <span>Owner suggerito: <b className="text-textmain">{a.suggested_owner}</b></span>
                                        <button className="text-[11.5px] text-primary hover:underline">Trasforma in task</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        </div>
    );
}
